import { render, staticRenderFns } from "./DeductionsType.vue?vue&type=template&id=9a329e40"
import script from "./DeductionsType.vue?vue&type=script&lang=js"
export * from "./DeductionsType.vue?vue&type=script&lang=js"
import style0 from "./DeductionsType.vue?vue&type=style&index=0&id=9a329e40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports